import { ElementRef, OnChanges, Renderer2, SimpleChanges, } from '@angular/core';
export var ProgressSize;
(function (ProgressSize) {
    ProgressSize["SMALL"] = "small";
    ProgressSize["LARGE"] = "large";
})(ProgressSize || (ProgressSize = {}));
export var ProgressFill;
(function (ProgressFill) {
    ProgressFill["DEFAULT"] = "default";
    ProgressFill["GRADIENT"] = "gradient";
})(ProgressFill || (ProgressFill = {}));
export var ProgressOrientation;
(function (ProgressOrientation) {
    ProgressOrientation["HORIZONTAL"] = "horizontal";
    ProgressOrientation["VERTICAL"] = "vertical";
})(ProgressOrientation || (ProgressOrientation = {}));
var ProgressBarComponent = /** @class */ (function () {
    function ProgressBarComponent(renderer) {
        this.renderer = renderer;
        this.fill = ProgressFill.DEFAULT;
        this.size = ProgressSize.SMALL;
        this.orientation = ProgressOrientation.HORIZONTAL;
        this.role = 'progressbar';
        this.valueMin = '0';
        this.valueMax = '100';
    }
    Object.defineProperty(ProgressBarComponent.prototype, "progressValue", {
        get: function () {
            return this.progressPercentage;
        },
        enumerable: true,
        configurable: true
    });
    ProgressBarComponent.prototype.ngOnChanges = function (changes) {
        if ('orientation' in changes) {
            this.cleanupView();
        }
        this.updateView();
    };
    ProgressBarComponent.prototype.updateView = function () {
        var progress = Math.min(Math.max(this.progressPercentage / 100, 0), 1);
        var progressStyle = this.progressHighlight.nativeElement;
        var property = this.orientation === ProgressOrientation.HORIZONTAL ? 'width' : 'height';
        this.renderer.setStyle(progressStyle, property, progress * 100 + "%");
        if (this.fill === ProgressFill.GRADIENT) {
            var gradientOrientation = this.orientation === ProgressOrientation.HORIZONTAL
                ? 'right'
                : 'bottom';
            /**
             * Sets background gradient with offset to retain color positions when width is changed
             * SASS variables: $blue to $aqua-light
             */
            var gradientOffset = progress ? (1 / progress) * 100 + "%" : null;
            this.progressHighlight.nativeElement.style.background = "linear-gradient(to " + gradientOrientation + ", #139ff0, #30dbe3 " + gradientOffset + ")";
        }
    };
    ProgressBarComponent.prototype.cleanupView = function () {
        var progressStyle = this.progressHighlight.nativeElement;
        this.renderer.removeStyle(progressStyle, 'width');
        this.renderer.removeStyle(progressStyle, 'height');
    };
    return ProgressBarComponent;
}());
export { ProgressBarComponent };
